import { render, staticRenderFns } from "./CustomAudioRecorderComponent.vue?vue&type=template&id=df626d22&lang=true"
import script from "./CustomAudioRecorderComponent.vue?vue&type=script&lang=js"
export * from "./CustomAudioRecorderComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomAudioRecorderComponent.vue?vue&type=style&index=0&id=df626d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports